import { LoginWithBookingDetailsFormValues } from '#/components/Form/LoginForm/LoginWithBookingDetailsFormSchema';
import { Brand } from '#/lib/brand';
import clientConfig from '@jucy-nakuru/config/clientConfig';
import { ParsedUrlQuery } from 'querystring';
import { Configuration, DefaultApi } from './generated/app-api';

export class AppApiClient extends DefaultApi {
    constructor(brand?: Brand) {
        const conf = new Configuration({
            basePath: `${brand === 'star' ? clientConfig.app.starUrl : clientConfig.app.url}`.replace(/\/$/, ''),
        });
        super(conf);
    }

    withToken(token: string | ((name?: string, scopes?: string[]) => string)): this {
        this.configuration = new Configuration({
            basePath: clientConfig.app.url,
            accessToken: token,
        });
        return this;
    }

    async login(values: LoginWithBookingDetailsFormValues, query?: ParsedUrlQuery): Promise<string> {
        const response = await this.request({
            path: '/api/auth/login',
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            query: { withBookingDetails: 'true', ...query },
            body: values,
        });
        const data = (await response.json()) as { url: string; error?: string };
        if (data.error) {
            throw new Error(data.error);
        }
        return data.url;
    }
}
